import type { Prototype } from "../prototype-types";

export const weiZhouPrototypes: Prototype[] = [
  {
    id: "wz-pie-generation-v2-keepers-2026-10-23",
    name: "PIE v2 keepers — retailer PDP",
    path: "/wz/pie-generation-v2-keepers-2026-10-23",
    description:
      "Current live Faire gallery vs Proposed + PIE keepers that fit remaining slots (cap 4). Production lq_image_enrichment after Faire type backfill. F flips, Q rotates.",
    owner: "Wei Zhou",
    createdAt: "2026-10-23",
    lastUpdated: "2026-10-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-pdp-attribute-cleanup-coverage-audit",
    name: "PDP attribute cleanup — coverage audit",
    path: "/wz/pdp-attribute-cleanup-coverage-audit",
    description:
      "Current vs category-regrouped PDP attributes across 902 coverage-driven products: 82 per mapped C1, rare-attribute coverage, real PDP galleries, and the standard human-audit questions.",
    owner: "Wei Zhou",
    createdAt: "2026-10-14",
    lastUpdated: "2026-10-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/6dbe19a1c8375db27f4f10b7bdf86e4f97ea1962e546f2b54a1ab52bd8d45cf9.jpeg?bg-color=FFFFFF&format=webp&fit=crop&precrop=2170,2170,x233,y236,safe&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-pie-pdp-before-after-2026-10-06",
    name: "PIE PDP — before vs after",
    path: "/wz/pie-pdp-before-after-2026-10-06",
    description:
      "Catalog top-4 vs PIE v2 cap-4 on a real retailer PDP. F/O flips before↔after. 56 XP products, 47 galleries change.",
    owner: "Wei Zhou",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/d0f58ad7c7cfded56163e6374048b95b2b6554534fca3941202d06923d484cf4.jpeg?bg-color=FEFFFE&format=webp&fit=crop&precrop=100p,100p,x0p,y0p&canvas=102.15p,150.01p,offset-x38.4p,offset-y50.3p&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-pdp-attribute-cleanup-llm-hard",
    name: "PDP attribute cleanup — hard audit",
    path: "/wz/pdp-attribute-cleanup-llm-hard",
    description:
      "Fast Current vs Cleaned audit on 132 hard listings (fabric/care, diet, sustainability, SEO dump). Prompt v11 + judge. F flips, Q rotates.",
    owner: "Wei Zhou",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/6dbe19a1c8375db27f4f10b7bdf86e4f97ea1962e546f2b54a1ab52bd8d45cf9.jpeg?bg-color=FFFFFF&format=webp&fit=crop&precrop=2170,2170,x233,y236,safe&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-pdp-attribute-cleanup-llm",
    name: "PDP attribute cleanup — LLM",
    path: "/wz/pdp-attribute-cleanup-llm",
    description:
      "Current vs LLM-regrouped PDP attributes (prompt v8). 39 LQ-sample listings, 3 per C1. SKU kept; Care Instructions; Shelf & Storage; Sustainability pills. F flips, Q rotates.",
    owner: "Wei Zhou",
    createdAt: "2026-10-01",
    lastUpdated: "2026-10-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/6dbe19a1c8375db27f4f10b7bdf86e4f97ea1962e546f2b54a1ab52bd8d45cf9.jpeg?bg-color=FFFFFF&format=webp&fit=crop&precrop=2170,2170,x233,y236,safe&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-pdp-attribute-cleanup",
    name: "PDP attribute cleanup",
    path: "/wz/pdp-attribute-cleanup",
    description:
      "Current vs cleaned PDP attributes. 500 listings from the LQ canonical sample (hash, 40 per C1). Title Case accordions; fiber blends normalized. F flips, Q rotates.",
    owner: "Wei Zhou",
    createdAt: "2026-09-28",
    lastUpdated: "2026-09-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/6dbe19a1c8375db27f4f10b7bdf86e4f97ea1962e546f2b54a1ab52bd8d45cf9.jpeg?bg-color=FFFFFF&format=webp&fit=crop&precrop=2170,2170,x233,y236,safe&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-description-bullet-summary-pdp",
    name: "Description bullet summary — scan fold",
    path: "/wz/description-bullet-summary-pdp",
    description:
      "AI Overview bullets vs the playground placeholder. Structured audit: needs Overview, is pipeline Overview helpful, write the optimal Overview. 199 products from description_overview (gpt-5-nano). F flips Overview, B cycles length band, Q rotates products, N focuses audit.",
    owner: "Wei Zhou",
    createdAt: "2026-09-25",
    lastUpdated: "2026-09-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/b96f57759ceea1a050e44929a606fdb8be1142fcb3d91020541c5068d32396dc.jpeg?bg-color=FFFFFF&format=webp&fit=crop&crop=1:1&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-description-overview-m1-audit",
    name: "Overview M1 audit — length × C1 sample",
    path: "/wz/description-overview-m1-audit",
    description:
      "Stratified Overview v2 audit. Q1 description scan (not brand story). Q2 whether attributes belong in Overview. Then prototype overlap, quality, and gold copy.",
    owner: "Wei Zhou",
    createdAt: "2026-09-29",
    lastUpdated: "2026-09-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/b96f57759ceea1a050e44929a606fdb8be1142fcb3d91020541c5068d32396dc.jpeg?bg-color=FFFFFF&format=webp&fit=crop&crop=1:1&w=600",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-prod-mobile",
    name: "Description format V2 — mobile PDP",
    path: "/wz/description-format-v2-prod-mobile",
    description:
      "Same sandbox DAG cohort as /wz/description-format-v2-prod on the native mobile PDP mock. F flips Original vs V2, Q next product.",
    owner: "Wei Zhou",
    createdAt: "2026-09-08",
    lastUpdated: "2026-09-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-video-start-point-clip-audit",
    name: "Video clip audit — zero-shot CLIP prototype",
    path: "/wz/video-start-point-clip-audit",
    description:
      "Current (t=0) vs Proposed (loops the CLIP-selected best sustained product-visible clip) on real product videos, with a per-2s content-type scrubber overlay + clip-range band. Shows only the 30 of 53 sampled videos with a meaningful (>=8s) clip change. Phase 0 of an auto-generated-highlight-clip direction.",
    owner: "Wei Zhou",
    createdAt: "2026-09-02",
    lastUpdated: "2026-09-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-title-format-search-tiles",
    name: "Title format search tiles",
    path: "/wz/title-format-search-tiles",
    description:
      "Original vs format-cleaned titles on the real search tile. Default shelves are frozen retailer queries so most titles do not change on F. Q then rotates issue-hunting shelves.",
    owner: "Wei Zhou",
    createdAt: "2026-08-26",
    lastUpdated: "2026-08-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/893f54403f4faedf2c4d3815eb466bcb42f01ddf6b621e0321ffa47875d73122.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v1-post-sqs-pdp",
    name: "Description format V1 Post-SQS PDP — Unicode Stripped Audit",
    path: "/wz/description-format-v1-post-sqs-pdp",
    description:
      "Original live description vs post-SQS Unicode stripped legacy V1 recommendations across 60 high-GMV listings ($61.15M GMV) on the real PDP. F flips copy, U toggles Unicode before/after, P opens SQS payload, Q rotates products.",
    owner: "Wei Zhou",
    createdAt: "2026-08-27",
    lastUpdated: "2026-08-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/c592398e7eb97d4bc4e8787544237f67e2b32874e4c0e6c1616cabb1ca2b66ea.png?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-pie-enrichment-sandbox-2026-10-13",
    name: "PIE sandbox keepers — 2026-10-13",
    path: "/wz/pie-enrichment-sandbox-2026-10-13",
    description:
      "Local Airflow sandbox PIE v2: live catalog vs 110 keepers on 85 of 213 products. F flips Current/Proposed, Q next.",
    owner: "Wei Zhou",
    createdAt: "2026-10-13",
    lastUpdated: "2026-10-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-pie-enrichment-sandbox-2026-10-14",
    name: "PIE sandbox keepers — 2026-10-14",
    path: "/wz/pie-enrichment-sandbox-2026-10-14",
    description:
      "Oct 14 sandbox vs catalog: unique extras only (pHash dups omitted). 0 keepers; labeled discard_gate. Default All. F flips, Q next.",
    owner: "Wei Zhou",
    createdAt: "2026-10-14",
    lastUpdated: "2026-10-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-pie-enrichment-sandbox-2026-10-14-oct13",
    name: "PIE adds vs Faire catalog — Oct 13 DAG",
    path: "/wz/pie-enrichment-sandbox-2026-10-14-oct13",
    description:
      "85 products with PIE adds from DAG 2026-10-13T22:39:40. Current = Faire catalog. Proposed = catalog + keepers. F flips. No-add products omitted.",
    owner: "Wei Zhou",
    createdAt: "2026-10-14",
    lastUpdated: "2026-10-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-pie-v1-vs-v2-audit",
    name: "PIE v1 vs v2 Audit & Comparison",
    path: "/wz/pie-v1-vs-v2-audit",
    description:
      "Side-by-side comparison of previous PIE v1 vs new PIE v2 on 56 products — context-aware similarity gating, hero near-duplicate pruning, and 4/6 gallery budgeting.",
    owner: "Wei Zhou",
    createdAt: "2026-08-21",
    lastUpdated: "2026-08-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-pie-similarity-bands",
    name: "PIE similarity bands",
    path: "/wz/pie-similarity-bands",
    description:
      "SigLIP2 cosine bands for PIE image adds, each paired against the existing image it is closest to. F flips the gallery, B rotates the band.",
    owner: "Wei Zhou",
    createdAt: "2026-08-19",
    lastUpdated: "2026-08-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-section-accordions",
    name: "Description format V2 — section accordions",
    path: "/wz/description-format-v2-section-accordions",
    description:
      "Mockup: V2 ## headers become accordions like attributes. Original PDP route is unchanged.",
    owner: "Wei Zhou",
    createdAt: "2026-08-18",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/e46e3c29bf8385d85a29adef0e799ebe6a3c48905971e5d86d89c2e89bb391bf.png?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-final",
    name: "Description format V2 — 16 Sep afternoon run",
    path: "/wz/description-format-v2-final",
    description:
      "The 16 Sep 13:56 run on its own — one V2 output per listing, no previous run to toggle to. F flips V2 against the control arm. Best round yet on the automated checks: clean rows 83%, sentence-initial lowercase back to 0, all-caps lines down to 1, stray trailing asterisks 47 down to 25, and only 6 listings withheld. Two defect classes are still unaddressed and both trace to layout rules that were retired: inconsistent bold in a list sits at 79 rows and one listing carries 115 bullets, because nothing reads MAX_PIPELINE_BULLETS any more. Note this run used dynamic selection rather than the pinned cohort, so 19 of the pinned 1,000 are missing and 507 rows have a control arm instead of 519; two reviewer-flagged listings are absent. Of the 109 flagged rows present, 36 are clean against the frozen baseline, 1 improved, 7 unchanged, 5 regressed, 60 unmeasurable. Opens on 'Needs checking'.",
    owner: "Wei Zhou",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-reviewable",
    name: "Description format V2 — every reviewable row",
    path: "/wz/description-format-v2-reviewable",
    description:
      "Every row worth looking at from the canonical sample, in one link — 100% of the defects rather than a slice. V2 has formatted 66,612 of the sample's products; all 66,612 were checked and 11,859 came back with something to see. This route carries all of them: 364 withheld by the Pass 4 judge, 11,495 tripping at least one automated probe, plus 141 clean rows so you can see what ordinary output looks like. A random 18% slice would have surfaced 18% of the defects; this surfaces all of them at the same page size. Across the full 66,612 the two known defects dominate: inconsistent bold in a list 7.8% and paragraphs over-split 7.6%, with everything else under 2% and sentence-initial lowercase essentially gone at 8 rows in 66,612. Every row compares against the brand's own description. The page is 19 MB so the first load takes a moment; filtering is instant after. R raw markdown, Q rotates, N notes, D diff.",
    owner: "Wei Zhou",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-canonical-sample",
    name: "Description format V2 — canonical sample products",
    path: "/wz/description-format-v2-canonical-sample",
    description:
      "6,000 products drawn from analytics.etl_datascience.lq_canonical_sample_products — the stable 100k canonical sample — joined to production V2 output, with everything already on an earlier audit link excluded. Worth knowing before you read it as full coverage: V2 has formatted 66,594 of the sample's 100,000, and of the 33,406 missing, 33,120 have a description and simply have not been processed yet; only 286 are legitimately skipped as empty. Health on the covered 66,594 is clean — zero errors, 352 withheld at 0.53%, every withhold a Pass 4 judge decision. On this 6,000-row slice 83% of rows come back with no automated check firing, the best rate of any cohort measured so far. The two known defects hold: paragraphs over-split 7.8%, inconsistent bold 7.5%, and 382 listings exceed 8 bullets because nothing enforces the ceiling. Every row compares against the brand's own description; none of these products has a V1 or V1.1 rewrite stored. R raw markdown, Q rotates, N notes, D diff.",
    owner: "Wei Zhou",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-prod-fresh",
    name: "Description format V2 — 6,000 unaudited products",
    path: "/wz/description-format-v2-prod-fresh",
    description:
      "6,000 production listings that have never appeared on any audit link — sampled at random from the 110,000 V2 has now formatted, with the 7,878 already shown on earlier routes excluded, and verified to have zero overlap. Every row here compares against the brand's own description, because none of these products has a V1 or V1.1 rewrite stored; the toolbar says Original throughout. Production at scale is healthy: 110,000 processed, zero errors, 712 withheld (0.65%), every withhold a Pass 4 judge decision rather than a failure. On this fresh sample 81% of rows are clean, matching the reviewed cohort, so the output holds up on products nobody tuned against. The two known defects also hold their rate: paragraphs over-split on 8.9% and inconsistent bold on 8.2%, and 566 listings carry more than 8 bullets. No product image or attribute accordion — images are not in canonical.products, and showing another product's photo would be worse than none. R raw markdown, Q rotates, N notes, D diff.",
    owner: "Wei Zhou",
    createdAt: "2026-09-17",
    lastUpdated: "2026-09-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-prod-mixed",
    name: "Description format V2 — production, random mix",
    path: "/wz/description-format-v2-prod-mixed",
    description:
      "Production only, both 17 Sep runs, in random order. The table now holds 10,000 distinct products because production excludes anything it has already processed, so the second run picked a different 5,000. This route carries 6,000 of them: every one of the 512 with a stored control arm, plus 5,488 sampled at random from the remaining 9,488. Crucially the order is shuffled rather than sorted by review status — the earlier route put all 512 control products at the front, so pressing Q walked through the control arm for a long time before reaching anything fresh. Now roughly 9 rows in 100 are control, matching their share. F compares against V1 or V1.1 where one exists and against the brand's own description otherwise. Production health across all 10,000: zero errors, 89 withheld (0.9%) and all by the Pass 4 judge. Opens on 'All rows'; 'Never reviewed' isolates the fresh products, 'Needs checking' the flagged ones. R raw markdown, Q rotates, N notes, D diff.",
    owner: "Wei Zhou",
    createdAt: "2026-09-17",
    lastUpdated: "2026-09-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-production",
    name: "Description format V2 — production output",
    path: "/wz/description-format-v2-production",
    description:
      "The first V2 output written by the merged code to the production table — analytics.etl_datascience.llm_formatted_description, 17 Sep 16:47, 5,000 listings. All 5,000 are here: 512 carry a stored control arm and F compares against V1 or V1.1, the other 4,488 compare against the brand's own description. Nothing failed — 5,000 processed, zero errors, 42 withheld (0.8%) and every one of those by the Pass 4 judge rather than a crash. Clean rows 82%, matching the last sandbox run, so the merge changed no behaviour. Of the 111 reviewer-flagged listings, 37 are clean against the frozen baseline, 3 improved, 8 unchanged, 2 regressed. Two known gaps carry over: inconsistent bold in a list on 82 rows, and 540 listings with more than 8 bullets because no rule enforces the ceiling. Opens on 'All rows'; 'Never reviewed' gives the 4,488 nobody has checked. R raw markdown, Q rotates, N notes, D diff.",
    owner: "Wei Zhou",
    createdAt: "2026-09-17",
    lastUpdated: "2026-09-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-broad",
    name: "Description format V2 — broad sweep",
    path: "/wz/description-format-v2-broad",
    description:
      "All 5,000 listings from the 16 Sep 17:56 run, not just the reviewed slice. 510 carry a stored control arm (V1 or V1.1) and are the set the team has been auditing; the other 4,490 have never been looked at and F compares them against the brand's own description, which is what V2 formats from. Opens on 'All rows'; the status filter has a 'Never reviewed' slice for the fresh 4,490 and 'Needs checking' for the flagged rows that are not yet demonstrably fixed. Two things are thinner on the unreviewed rows: no product image (images are not in canonical.products, and borrowing another product's photo would let you judge copy against the wrong item) and no attribute accordion. Cohort-wide: clean rows 82%, 43 withheld, sentence-initial lowercase 0, inconsistent bold still the largest defect class. R shows raw markdown, Q rotates, N focuses notes, D diffs.",
    owner: "Wei Zhou",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-newschema",
    name: "Description format V2 — versioned output table",
    path: "/wz/description-format-v2-newschema",
    description:
      "The 16 Sep 17:56 run on its own — one V2 output per listing, no previous run to toggle to. F flips V2 against the control arm. First run on the new versioned output table, and the schema behaved: detections and changes come back as queryable objects, transformations as an array, metrics NULL because V2 records none. The run itself covered 5,000 products rather than the pinned 1,000 and resampled, so 510 of them have a control arm and appear here, and one reviewer-flagged listing is absent. Of the 110 flagged rows present, 37 are clean against the frozen baseline — the best of any round — with 3 improved, 7 unchanged and only 2 regressed. Clean rows 82%, sentence-initial lowercase 0, all-caps lines 4. Inconsistent bold is still the largest defect class at 82 rows, and the bullet ceiling is still unenforced. Opens on 'Needs checking'. R raw markdown, Q rotates, N notes, D diff.",
    owner: "Wei Zhou",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-recase",
    name: "Description format V2 — label recase",
    path: "/wz/description-format-v2-recase",
    description:
      "The 16 Sep 02:46 run on its own — one V2 output per listing, no previous run to toggle to. 519 of the pinned 1,000 products have a control arm; F flips V2 against it. Shouted attribute labels are fixed: MATERIALS / SHELF LIFE / PERFECTLY GLAZED PECANS now read as Title Case bold labels, and sentence-initial lowercase halved from 17 rows to 8. Of the 111 listings reviewers flagged, 37 are now clean against the frozen baseline — the best of any round — with 2 improved, 8 unchanged, 3 regressed and 61 unmeasurable. Clean rows sit at 82%, still short of the 86% before Pass 3 was cut back: inconsistent bold is 80 rows, '###' headings 559, and one listing carries 116 bullets. Opens on 'Needs checking'. R shows raw markdown, Q rotates, N focuses notes, D diffs against control.",
    owner: "Wei Zhou",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-current",
    name: "Description format V2 — current output",
    path: "/wz/description-format-v2-current",
    description:
      "The 16 Sep 00:06 run on its own — one V2 output per listing, no previous run to toggle to. 519 of the pinned 1,000 products have a control arm; F flips V2 against it. This is the first run since Pass 3 dropped from fifteen layout rules to three, and it shows: clean rows fell from 86% to 81%, inconsistent bold in a list went 15 rows to 72, sentence-initial lowercase 0 to 17, and '###' headings 206 to 585. Fewer rows are withheld though — 10 rather than 32 — because only the Pass 4 judge withholds now, so 990 listings ship rather than 968. Of the 111 listings reviewers flagged, 33 are clean against the frozen baseline, 2 improved, 11 unchanged, 4 regressed and 61 unmeasurable. Opens on 'Needs checking'. R shows raw markdown, Q rotates, N focuses notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-prompts",
    name: "Description format V2 — prompt and layout fixes",
    path: "/wz/description-format-v2-prompts",
    description:
      "The run after the prompt and layout fixes. Same pinned 1,000-product cohort, 519 listings with a control arm: 15 Sep 18:26 against 15 Sep 03:20. Press P to switch \u2014 the strip across the top names which run is on screen, green for the new one. Two checks went to almost nothing: sentence-initial lowercase from 88 rows to 0, all-caps lines from 30 to 1. Inconsistent bold fell 69 to 15 and over-splitting held at 47. Headings dropped from 535 to 206 \u2014 attributes are bold labels now, not headers. Clean rows held at 86%. Of the 111 listings reviewers flagged, 45 are now clean against the frozen baseline, 1 improved, 4 unchanged and none regressed; 61 stay unmeasurable \u2014 bare verdicts or matters of taste no check can see, and those are the ones that still need eyes. One known defect is still in this output: a brand's own bulleted list was flattened into a run-on line on 1 row (fixed in code, not yet re-run). Opens on 'Needs checking'. Press F to switch arms, R for raw markdown, Q to rotate, N for your own notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-nosplit",
    name: "Description format V2 — no paragraph splitting",
    path: "/wz/description-format-v2-nosplit",
    description:
      "The run that stopped splitting paragraphs. Same pinned 1,000-product cohort, 519 listings with a control arm: 15 Sep 03:20 (v4.0.123) against 15 Sep 00:38 (v4.0.117). Press P to switch \u2014 the strip across the top names which run is on screen, green for the new one. Clean rows, meaning listings where no automated check fires at all, went from 77% to 87%. Over-splitting fell from 280 rows to 47, all-caps lines from 30 to 1, sentence-initial lowercase from 88 to 15, inconsistent bold from 69 to 14. Of the 111 listings reviewers have flagged, 43 are now clean against the frozen baseline and 1 regressed. 61 remain unmeasurable \u2014 bare verdicts or matters of taste that no check can see, and those are the ones that still need eyes. Opens on 'Needs checking'. Press F to switch arms, R for raw markdown, Q to rotate, N for your own notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-ab-0915",
    name: "Description format V2 — old vs new",
    path: "/wz/description-format-v2-ab-0915",
    description:
      "Old V2 against new V2 on the same pinned 1,000-product cohort: the 14 Sep run (v4.0.113, the one you audited last) versus the 15 Sep run (v4.0.117). Press P to switch between them \u2014 the strip across the top always names which one is on screen, green for the new run and amber for the old, and the export records it too. 519 listings have a control arm; all 111 a reviewer has ever flagged are marked and carry their verdict and their words. Opens on 'Needs checking'. Against the frozen baseline the probes now call 33 fixed, 1 improved, 15 unchanged, 1 regressed and 61 unmeasurable. Cohort-wide since the first audit: over-breaking 280 rows to 116, inconsistent bold 69 to 14, all-caps 30 to 18, sentence-initial lowercase 88 to 53. Withheld rows fell from 48 to 31. 172 listings changed between these two runs. Press F to switch arms, R for raw markdown, Q to rotate, N for your own notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-recheck",
    name: "Description format V2 — did the fixes land",
    path: "/wz/description-format-v2-recheck",
    description:
      "Did the fixes land? The same 1,000-product pinned cohort, re-run on 14 Sep 22:54 with v4.0.113, showing the 519 listings that have a control arm. Every listing a reviewer flagged last round is marked and carries their verdict and their words, so you can read the original complaint and the current output side by side; press P to see what that listing looked like when they reviewed it. Of the 111 flagged rows the probes call 32 fixed, 1 improved, 15 unchanged, 2 regressed, and 61 unmeasurable \u2014 those last ones still need eyes. Opens on 'Needs checking', which is every flagged row not yet demonstrably fixed. Cohort-wide the over-breaking fix halved block growth (280 rows to 136), inconsistent bold in lists fell 69 to 13, and all-caps lines 30 to 20. 48 rows were withheld this run and ship the control arm instead. Press F to switch arms, R for raw markdown, Q to rotate, N for your own notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-14",
    lastUpdated: "2026-09-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-pdp-team-notes",
    name: "Description format V2 — team audit verdicts",
    path: "/wz/description-format-v2-pdp-team-notes",
    description:
      "The verdicts the team mailed back, readable in place next to the listing each one is about. Audit notes are saved per browser, so nobody could see anyone else's: these are Brock's, Leyao's and Tiff's exports folded into the page. 111 rows carry a verdict or a note across 520 listings \u2014 78 good, 25 minor, 4 broken. The cohort is the union of the two runs the team actually reviewed, because no single run carries everyone's notes: Brock and Leyao read the 268-listing 10 Sep run before the shared route was refreshed, Tiff read the 367-listing 11 Sep run after, and their token sets overlap on only 13 rows. Each noted listing shows the V2 text its own reviewer saw, badged with which run it came from, and rows whose output has since changed or been dropped say so. Filter by verdict, by issue tag, or by who sent it; press F to switch arms, R for raw markdown, Q to rotate, N for your own notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-14",
    lastUpdated: "2026-09-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-pdp-2026-09-11",
    name: "Description format V2 on the PDP — 11 Sep run",
    path: "/wz/description-format-v2-pdp-2026-09-11",
    description:
      "V2 against the arm it has to beat, on the real retailer PDP with the three-line description clamp retailers actually land on. 367 listings sampled from a 1,000-product sandbox run of 11 Sep 21:16 UTC, each paired with the product's V1.1 rewrite if it has one, else V1, else the brand original (262 V1, 70 V1.1, 35 Original). Pick your name in the first dropdown to see only your slice: the cohort is split evenly across Wei, Don, Tiff, Em, Brock, Leyao and Liam at 52 or 53 each, striped within control arms so everyone gets the same mix. Anyone already reviewing a product from the previous cohort keeps it. Press F to switch arms, R for V2's raw markdown, Q to rotate products, N for audit notes. This run carries the ordered-steps double-numbering fix (0 rows affected, down from 8 in 20), the tightened section-header detector, the table width budget measured in characters rather than columns, and an emphasis pass that is now unconditional. 24 rows of the 1,000 were withheld by the judge or a guardrail and emit nothing, so they are absent here by design.",
    owner: "Wei Zhou",
    createdAt: "2026-09-11",
    lastUpdated: "2026-09-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-description-format-v2-baseline-audit",
    name: "Description format V2 vs V1/V1.1 baseline",
    path: "/wz/description-format-v2-baseline-audit",
    description:
      "XP control vs treatment for description formatting. 186 listings from the description_format_v2 sandbox run, each against the text V2 has to beat: the product's V1.1 rewrite if it has one, else V1, else the brand original (135 V1, 33 V1.1, 18 Original). Press F to switch arms — the toolbar names which control version you are seeing. Control renders as plaintext and treatment as markdown, matching what each arm ships. Pass 4 judge verdicts show inline. A 'layered on V1' badge marks the 12 rows where this run read V1's output rather than the brand original. Q rotates products, N focuses audit notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-09",
    lastUpdated: "2026-09-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-prod",
    name: "Description format V2 — real pipeline output",
    path: "/wz/description-format-v2-prod",
    description:
      "60 listings straight out of the first real description_format_v2 sandbox DAG run — not a local re-run. Rule pills and guardrail verdicts come from the stored pipeline metrics. F flips copy, Q rotates products, N focuses audit notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-02",
    lastUpdated: "2026-09-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-quality-spotcheck",
    name: "Description format V2 — quality spot-check",
    path: "/wz/description-format-v2-quality-spotcheck",
    description:
      "Production V2 quality audit: 50 shipped listings with ≥5 bold spans + 20 judge withholds. Filter Heavy bold / Withhold. F flips Original vs V2, Q next, N notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-launch-party",
    name: "Description format V2 — launch party",
    path: "/wz/description-format-v2-launch-party",
    description:
      "Balanced production sample for launch review: 12 products per semantic change type (Ingredients, Ordered list, Spec grid, SEO prune, Size chart, Bullets, Headers, Key info) + 4 withholds per judge reason (116 total). Filter by rule pill. F flips, Q next, N notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-21",
    lastUpdated: "2026-09-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-fixed",
    name: "Description format V2 — post-fix verification",
    path: "/wz/description-format-v2-fixed",
    description:
      "Re-run of the 14 KEEP audit listings after the prompt-echo, heading-depth and paragraph-length fixes, on real catalog copy. No prompt echo, no heading above ###, no paragraph over 280 chars. Opens on p_bxkbbswage. F flips copy, Q rotates products, N focuses audit notes.",
    owner: "Wei Zhou",
    createdAt: "2026-09-02",
    lastUpdated: "2026-09-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-keep",
    name: "Description format V2 KEEP — ingredient hierarchy on PDP",
    path: "/wz/description-format-v2-keep",
    description:
      "Live V2 KEEP on 14 eval products: ALL-CAPS herb names become Title Case ### headers. Opens on p_bxkbbswage. F flips copy, Q rotates products, N focuses audit notes. Copy notes JSON to iterate on the KEEP prompt.",
    owner: "Wei Zhou",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-01",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/7e342333965840b9f21edd1104ecf0cf7c0e13500564db03675ac6249eb03ca9.jpeg?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v1.1-pdp",
    name: "Description format V1.1 PDP — Consolidated DAG Run Audit",
    path: "/wz/description-format-v1.1-pdp",
    description:
      "Original live description vs proposed V1.1 formatting (GPT-5.6 Luna, no unicode bold) across a random 445-product sample from the 2026-09-02 production DAG incrementals. F flips copy, Q rotates products.",
    owner: "Wei Zhou",
    createdAt: "2026-08-24",
    lastUpdated: "2026-09-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/e46e3c29bf8385d85a29adef0e799ebe6a3c48905971e5d86d89c2e89bb391bf.png?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-hangfix-e2e",
    name: "Description format — Hang-fix sandbox E2E audit",
    path: "/wz/description-format-hangfix-e2e",
    description:
      "Original vs hang-fix Batch path rewrites (V1.1 / GPT-5.6 Luna) on a random 180-product sample from sandbox description_format_incremental_manual_airflow_{0,1}. F flips copy, Q rotates products.",
    owner: "Wei Zhou",
    createdAt: "2026-09-25",
    lastUpdated: "2026-09-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/e46e3c29bf8385d85a29adef0e799ebe6a3c48905971e5d86d89c2e89bb391bf.png?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-description-format-v2-pdp",
    name: "Description format V2 PDP — GPT-5.6 Luna Audit",
    path: "/wz/description-format-v2-pdp",
    description:
      "Original live description vs proposed GPT-5.6 Luna markdown across 200 products on the real PDP. F flips copy, Q rotates products.",
    owner: "Wei Zhou",
    createdAt: "2026-08-18",
    lastUpdated: "2026-08-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/e46e3c29bf8385d85a29adef0e799ebe6a3c48905971e5d86d89c2e89bb391bf.png?w=600&fm=webp",
    creationTool: "cursor",
  },
  {
    id: "wz-image-ordering-vlm-pdp",
    name: "VLM image ordering PDP",
    path: "/wz/image-ordering-vlm-pdp",
    description: "Audri cohort rerun (apparel soft-prompt + low-res) — Δ > 0.2",
    owner: "Wei Zhou",
    createdAt: "2026-08-11",
    lastUpdated: "2026-08-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-image-ordering-vlm-pdp-apparel-2026-08-13",
    name: "VLM order PDP — apparel soft-prompt (2026-08-13)",
    path: "/wz/image-ordering-vlm-pdp-apparel-2026-08-13",
    description:
      "Stratified ~½ Apparel cohort after soft apparel generate prompt — Δ > 0.2",
    owner: "Wei Zhou",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-image-ordering-vlm-pdp-apparel-lowres-2026-08-13",
    name: "VLM order PDP — apparel + low-res (2026-08-13)",
    path: "/wz/image-ordering-vlm-pdp-apparel-lowres-2026-08-13",
    description:
      "Apparel soft-prompt + low-res filter (WIDTH/HEIGHT > 600) — Δ > 0.2",
    owner: "Wei Zhou",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
  {
    id: "wz-image-ordering-vlm-pdp-prod-2026-08-13",
    name: "VLM order PDP — top 500 GMV products",
    path: "/wz/image-ordering-vlm-pdp-prod-2026-08-13",
    description:
      "Top 500 lifetime GMV products ($159k–$1.98M) from production VLM order run — Δ > 0.2",
    owner: "Wei Zhou",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/972feb222a9545c84e1b58fe3df9694576ea0660882ab4d4c3d391bf45b364e9.jpeg?w=600&fm=webp",
    creationTool: "claude-code",
  },
];
